'use client';

import React, { useState, memo, useRef } from 'react';
import styles from './Video.module.scss';

const Video = memo(function Video({ video, textBlock }) {
  const [getItemContentIndex, setGetItemContentIndex] = useState(0);
  const videoRef = useRef(null);

  const handleSelect = (value) => {
    setGetItemContentIndex(value);

    if (!videoRef.current) {
      return;
    }

    if (value === 1) {
      videoRef.current.play();
    } else {
      videoRef.current.pause();
    }
  };

  const getVideoUrl = (videoData) => {
    if (videoData && videoData.value) {
      return videoData.value.href || videoData.value.url || '';
    }
    if (videoData && videoData.fields) {
      return videoData.fields.url?.value || videoData.fields.videoUrl?.value || '';
    }
    return videoData?.url || '';
  };

  const getTextBlockTitle = (textBlockData) => {
    if (textBlockData && textBlockData.title) {
      return textBlockData.title.value || textBlockData.title.value === ''
        ? textBlockData.title.value
        : textBlockData.title;
    }
    return textBlockData?.title || '';
  };

  const getTextBlockText = (textBlockData) => {
    if (textBlockData && textBlockData.text) {
      return textBlockData.text.value || textBlockData.text.value === ''
        ? textBlockData.text.value
        : textBlockData.text;
    }
    return textBlockData?.text || '';
  };

  const videoUrl = getVideoUrl(video);
  const title = getTextBlockTitle(textBlock);
  const text = getTextBlockText(textBlock);

  // 添加调试信息

  if (!videoUrl) {
    return null;
  }

  return (
    <div className="container">
      <div className={styles.video}>
        <div className={styles.video_wrapper} data-aos="fade-up">
          <video
            ref={videoRef}
            className={styles.video_container}
            src={videoUrl + '#t=0.001'}
            muted={true}
            playsInline
            preload="metadata"
            style={{ borderRadius: '20px', width: '100%', height: '100%', objectFit: 'cover' }}
            onEnded={() => handleSelect(0)}
          />
          {getItemContentIndex === 0 && (
            <button className={styles.play_button} onClick={() => handleSelect(1)}>
              <div className={styles.triangle}></div>
            </button>
          )}
          {getItemContentIndex === 1 && (
            <button className={styles.pause_button} onClick={() => handleSelect(0)}>
              <div className={styles.rectangle}></div>
              <div className={styles.rectangle}></div>
            </button>
          )}
        </div>
        {(title || text) && (
          <div className={styles.video_details} data-aos="fade-up">
            {title && <h2 className={styles.video_details__headline}>{title}</h2>}
            {text && (
              <div className={styles.video_details__description}>
                <div dangerouslySetInnerHTML={{ __html: text || '' }} />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
});

export default Video;
